import { _t } from 'common/utils/translations';
export default {
    root: function (_a) {
        var state = _a.state;
        return ({
            class: [
                'tw-font-sans tw-bg-white tw-overflow-hidden tw-shadow-xl tw-transform tw-transition-all tw-w-full dark:tw-bg-zinc-700',
                'tw-shadow-lg tw-border-0',
                'tw-transform tw-scale-100',
                {
                    '!tw-w-screen !tw-h-screen !tw-max-h-full !tw-top-0 !tw-left-0 landscape:sm:!tw-max-w-[unset]': state.maximized,
                    'tw-max-h-[90vh] tw-mx-1.5 tw-my-2 tw-rounded-md': !state.maximized,
                },
            ],
        });
    },
    header: {
        class: [
            'tw-flex tw-items-center tw-justify-between tw-shrink-0',
            'tw-text-gray-800 tw-border-t-0 tw-rounded-tl-lg tw-rounded-tr-lg tw-py-4 tw-px-2 lg:tw-px-4',
            'dark:tw-text-white/80',
        ],
    },
    icons: {
        class: ['tw-ml-auto'],
    },
    title: {
        class: 'tw-font-medium tw-text-xl',
    },
    headerActions: {
        class: 'tw-ml-auto tw-flex tw-items-center',
    },
    headerIcon: {
        root: {
            class: [
                'tw-flex tw-items-center tw-justify-center tw-overflow-hidden tw-relative',
                'tw-w-8 tw-h-8 tw-border-0 tw-bg-transparent tw-rounded-full tw-transition tw-duration-200 tw-ease-in-out tw-mr-2 last:tw-mr-0',
                'tw-text-gray-600 hover:tw-text-gray-700 hover:tw-bg-gray-200',
                'dark:tw-text-gray-300 dark:hover:tw-gray-200 dark:hover:tw-bg-zinc-800/50',
                'focus:tw-outline-none focus:tw-ring-0 focus:tw-ring-offset-0 focus-visible:tw-outline-2 focus-visible:tw-ring-2 focus-visible:tw-ring-offset-2 focus-visible:tw-ring-primary-700',
            ],
        },
    },
    pcCloseButton: {
        root: {
            class: ['tw-p-1.5'],
            title: _t('zavrit'),
        },
        label: {
            class: 'tw-hidden',
        },
    },
    closeButtonIcon: {
        class: 'tw-w-4 tw-h-4 tw-inline-block',
    },
    content: function (_a) {
        var state = _a.state, props = _a.props;
        return ({
            // eslint-disable-next-line no-sparse-arrays
            class: [
                'tw-h-full',
                'tw-overflow-y-auto',
                'tw-text-gray-900 tw-px-2 tw-pb-4 tw-pt-0 lg:tw-px-4',
                'dark:tw-text-gray-100',
                {
                    'tw-grow': state.maximized,
                },
                {
                    'tw-rounded-bl-lg tw-rounded-br-lg': !props.footer,
                },
            ],
        });
    },
    footer: {
        class: [
            'tw-flex tw-gap-2 tw-shrink-0 tw-justify-end tw-align-center',
            'tw-border-t-0 tw-bg-white tw-text-gray-700 tw-px-6 tw-pb-6 tw-text-right tw-rounded-b-lg',
            'dark:tw-bg-zinc-700  dark:tw-text-white/80',
        ],
    },
    mask: function (_a) {
        var props = _a.props;
        return ({
            class: ['tw-transition tw-duration-200', { 'tw-bg-black/40': props.modal }],
        });
    },
    transition: function (_a) {
        var props = _a.props;
        return props.position === 'top'
            ? {
                enterFromClass: 'tw-opacity-0 tw-scale-75 tw-translate-x-0 -translate-y-full translate-z-0',
                enterActiveClass: 'tw-transition-all tw-duration-200 tw-ease-out',
                leaveActiveClass: 'tw-transition-all tw-duration-200 tw-ease-out',
                leaveToClass: 'tw-opacity-0 tw-scale-75 tw-translate-x-0 -translate-y-full translate-z-0',
            }
            : props.position === 'bottom'
                ? {
                    enterFromClass: 'tw-opacity-0 tw-scale-75 tw-translate-y-full',
                    enterActiveClass: 'tw-transition-all tw-duration-200 tw-ease-out',
                    leaveActiveClass: 'tw-transition-all tw-duration-200 tw-ease-out',
                    leaveToClass: 'tw-opacity-0 tw-scale-75 tw-translate-x-0 tw-translate-y-full tw-translate-z-0',
                }
                : props.position === 'left' || props.position === 'topleft' || props.position === 'bottomleft'
                    ? {
                        enterFromClass: 'tw-opacity-0 tw-scale-75 -tw-translate-x-full tw-translate-y-0 translate-z-0',
                        enterActiveClass: 'tw-transition-all tw-duration-200 tw-ease-out',
                        leaveActiveClass: 'tw-transition-all tw-duration-200 tw-ease-out',
                        leaveToClass: 'tw-opacity-0 tw-scale-75 -tw-translate-x-full tw-translate-y-0 translate-z-0',
                    }
                    : props.position === 'right' || props.position === 'topright' || props.position === 'bottomright'
                        ? {
                            enterFromClass: 'tw-opacity-0 tw-scale-75 tw-translate-x-full tw-translate-y-0 tw-translate-z-0',
                            enterActiveClass: 'tw-transition-all tw-duration-200 tw-ease-out',
                            leaveActiveClass: 'tw-transition-all tw-duration-200 tw-ease-out',
                            leaveToClass: 'tw-opacity-0 tw-scale-75 tw-opacity-0 tw-scale-75 tw-translate-x-full tw-translate-y-0 tw-translate-z-0',
                        }
                        : {
                            enterFromClass: 'tw-opacity-0 tw-scale-75',
                            enterActiveClass: 'tw-transition-all tw-duration-200 tw-ease-out',
                            leaveActiveClass: 'tw-transition-all tw-duration-200 tw-ease-out',
                            leaveToClass: 'tw-opacity-0 tw-scale-75',
                        };
    },
};
